(() => {
  if (window.pushpauraProductControlsLoaded) return;
  window.pushpauraProductControlsLoaded = true;

  const desktopQuery = window.matchMedia('(min-width: 990px)');
  const cartUrl = () => window.routes?.cart_url || '/cart';
  const parseResponse = async (response, fallbackMessage) => {
    const data = await response.json();
    if (!response.ok || data.status) {
      throw new Error(data.description || data.message || fallbackMessage);
    }
    return data;
  };

  document.querySelectorAll('[data-size-chart-dialog]').forEach((dialog) => {
    const openButtons = document.querySelectorAll(`[aria-controls="${dialog.id}"]`);
    const closeButton = dialog.querySelector('[data-close-size-chart]');

    openButtons.forEach((button) => {
      button.addEventListener('click', () => dialog.showModal());
    });
    closeButton?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  });

  document.querySelectorAll('.pushpaura-product-page').forEach((productPage) => {
    const productInfo = productPage.closest('product-info');
    const productForm = productPage.querySelector('product-form.product-form--cart-stepper');
    const form = productForm?.querySelector('form');
    if (!productInfo || !productForm || !form) return;

    const variantInput = form.querySelector('[name="id"]');
    const nativeQuantity = productPage.querySelector('.product-form__quantity .quantity__input');
    const sizeChoices = Array.from(document.querySelectorAll('[data-product-size-choice]')).filter((choice) => choice.form === form);
    const selectedSize = () => sizeChoices.find((choice) => choice.checked)?.value || '';
    const stickySize = productPage.querySelector('[data-sticky-size]');
    const stickyQuantity = productPage.querySelector('[data-sticky-initial-quantity]');
    const stickyQuantityValue = stickyQuantity?.querySelector('[data-sticky-quantity-value]');
    const syncStickyOption = (optionName, value) => {
      const optionInputs = Array.from(productPage.querySelectorAll('[data-option-name]'))
        .filter((input) => input.dataset.optionName === optionName && input.value === value);
      if (optionInputs.length) {
        optionInputs.find((input) => !input.disabled)?.click();
        return;
      }
      const optionSelect = Array.from(productPage.querySelectorAll('variant-selects select[name^="options["]'))
        .find((select) => select.name === `options[${optionName}]`);
      if (optionSelect && optionSelect.value !== value) {
        optionSelect.value = value;
        optionSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    };
    const syncStickyOptionControls = () => {
      productPage.querySelectorAll('[data-sticky-option]').forEach((control) => {
        const optionName = control.dataset.stickyOption;
        const checked = Array.from(productPage.querySelectorAll('[data-option-name]'))
          .find((input) => input.dataset.optionName === optionName && input.checked);
        const nativeSelect = Array.from(productPage.querySelectorAll('variant-selects select[name^="options["]'))
          .find((select) => select.name === `options[${optionName}]`);
        const selectedValue = checked?.value || nativeSelect?.value;
        if (selectedValue && control.value !== selectedValue) control.value = selectedValue;
      });
      if (stickySize && sizeChoices.length) stickySize.value = selectedSize();
    };
    const addButtons = [
      productForm.querySelector('.product-form__submit'),
      productPage.querySelector('.pushpaura-sticky-cart__button'),
    ].filter(Boolean);
    const acceleratedCheckout = Array.from(form.querySelectorAll('.shopify-payment-button'));
    const steppers = Array.from(productPage.querySelectorAll('[data-product-stepper]'));
    const statusMessages = Array.from(productPage.querySelectorAll('[data-product-cart-status]'));
    const messages = form.querySelector('[data-product-cart-messages]');
    const message = (key, fallback) => messages?.dataset[key] || fallback;
    const busyButtons = () => steppers.flatMap((stepper) => Array.from(stepper.querySelectorAll('button')));
    let busy = false;
    let syncSequence = 0;

    const setStatus = (message, isError = false) => {
      statusMessages.forEach((element) => {
        element.textContent = message;
        element.classList.toggle('is-error', isError);
      });
    };

    if (sizeChoices.length) {
      form.addEventListener('submit', (event) => {
        if (selectedSize()) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        setStatus(message('sizeRequired', 'Please select a size before adding this item to your cart.'), true);
        sizeChoices[0].focus();
      }, true);
    }

    const setControls = (quantity) => {
      const isDesktop = desktopQuery.matches;
      const sizeRequired = sizeChoices.length > 0;
      const sizeSelected = !sizeRequired || Boolean(selectedSize());
      addButtons.forEach((button) => {
        button.hidden = isDesktop && quantity > 0;
      });
      acceleratedCheckout.forEach((button) => {
        button.hidden = !sizeSelected;
      });
      steppers.forEach((stepper) => {
        stepper.hidden = !isDesktop || quantity < 1;
        const count = stepper.querySelector('[data-product-stepper-count]');
        if (count) count.value = String(quantity);
        if (count) count.textContent = String(quantity);
      });
      if (stickyQuantity && stickyQuantityValue) {
        stickyQuantity.hidden = !isDesktop || quantity > 0;
        stickyQuantityValue.textContent = String(Math.max(Number(nativeQuantity?.value || 1), 1));
      }
      busyButtons().forEach((button) => {
        const isIncrease = button.dataset.productStep === 'increase';
        button.disabled = busy || (isIncrease && Boolean(productForm.querySelector('.product-form__submit')?.disabled));
      });
    };

    const getCart = async () => {
      const response = await fetch(`${cartUrl()}.js`, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) throw new Error(message('loadError', 'Your cart could not be loaded. Please refresh and try again.'));
      return response.json();
    };

    const matchingItems = (cart, variantId) => (cart.items || []).filter((item) => {
      if (String(item.variant_id) !== String(variantId)) return false;
      return !sizeChoices.length || item.properties?.Size === selectedSize();
    });

    const refreshControls = async () => {
      if (!desktopQuery.matches || !variantInput?.value || (sizeChoices.length && !selectedSize())) {
        setControls(0);
        return;
      }

      const sequence = ++syncSequence;
      try {
        const cart = await getCart();
        if (sequence !== syncSequence) return;
        const quantity = matchingItems(cart, variantInput.value).reduce((total, item) => total + item.quantity, 0);
        setControls(quantity);
      } catch (error) {
        setControls(0);
      }
    };

    const sectionIds = () => {
      const drawer = document.querySelector('cart-drawer');
      return drawer?.getSectionsToRender?.().map((section) => section.id) || [];
    };

    const postCartChange = async (url, body) => {
      const ajaxUrl = url.endsWith('.js') ? url : `${url}.js`;
      const sections = sectionIds();
      const response = await fetch(ajaxUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...body,
          ...(sections.length ? { sections } : {}),
          sections_url: window.location.pathname,
        }),
      });
      const data = await parseResponse(response, message('updateError', 'Your cart could not be updated. Please try again.'));
      const drawer = document.querySelector('cart-drawer');
      if (drawer && data.sections) {
        drawer.classList.toggle('is-empty', Number(data.item_count) === 0);
        drawer.getSectionsToRender().forEach((section) => {
          const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);
          const html = data.sections[section.id];
          if (!sectionElement || !html) return;
          sectionElement.innerHTML = drawer.getSectionInnerHTML(html, section.selector);
        });
      }
      return data;
    };

    const changeQuantity = async (action) => {
      if (!desktopQuery.matches || busy || !variantInput?.value || (sizeChoices.length && !selectedSize())) return;
      busy = true;
      setStatus(message('updating', 'Updating quantity…'));
      setControls(Number(steppers[0]?.querySelector('[data-product-stepper-count]')?.textContent || 0));

      try {
        const cart = await getCart();
        const items = matchingItems(cart, variantInput.value);
        const currentQuantity = items.reduce((total, item) => total + item.quantity, 0);
        const step = Math.max(Number(nativeQuantity?.step || 1), 1);

        if (action === 'increase') {
          const max = Number(nativeQuantity?.dataset.max || nativeQuantity?.max || 0);
          if (max && currentQuantity + step > max) {
            throw new Error(message('maxQuantity', 'The maximum quantity for this size is [quantity].').replace('[quantity]', String(max)));
          }

          const addItem = {
            id: Number(variantInput.value),
            quantity: step,
          };
          if (sizeChoices.length) addItem.properties = { Size: selectedSize() };
          await postCartChange(window.routes?.cart_add_url || `${cartUrl()}/add`, addItem);
        } else {
          const line = items.find((item) => item.quantity >= step) || items[0];
          if (!line) {
            setControls(0);
            setStatus('');
            return;
          }
          await postCartChange(window.routes?.cart_change_url || `${cartUrl()}/change`, {
            id: line.key,
            quantity: Math.max(line.quantity - step, 0),
          });
        }

        await refreshControls();
        const updatedQuantity = Number(steppers[0]?.querySelector('[data-product-stepper-count]')?.textContent || 0);
        if (updatedQuantity > 0) {
          setStatus(message('updated', 'Quantity updated to [quantity].').replace('[quantity]', String(updatedQuantity)));
        } else {
          setStatus('');
        }
      } catch (error) {
        setStatus(error.message || message('updateError', 'Your cart could not be updated. Please try again.'), true);
      } finally {
        busy = false;
        const count = Number(steppers[0]?.querySelector('[data-product-stepper-count]')?.textContent || 0);
        setControls(count);
      }
    };

    productPage.addEventListener('click', (event) => {
      const stickyChooseOptions = event.target.closest('[data-sticky-add-button]');
      if (stickyChooseOptions && !desktopQuery.matches) {
        const optionPicker = productPage.querySelector(
          '.pushpaura-product-size-option, variant-radios, variant-selects, .product-form__input'
        );
        if (optionPicker) {
          event.preventDefault();
          optionPicker.scrollIntoView({ behavior: 'smooth', block: 'center' });
          optionPicker.querySelector('input:not(:disabled), select')?.focus({ preventScroll: true });
          return;
        }
      }

      const initialQuantityButton = event.target.closest('[data-sticky-quantity]');
      if (initialQuantityButton && productPage.contains(initialQuantityButton)) {
        const current = Math.max(Number(nativeQuantity?.value || 1), 1);
        const step = Math.max(Number(nativeQuantity?.step || 1), 1);
        const max = Number(nativeQuantity?.dataset.max || nativeQuantity?.max || 0);
        const next = initialQuantityButton.dataset.stickyQuantity === 'increase'
          ? (max ? Math.min(current + step, max) : current + step)
          : Math.max(current - step, step);
        if (nativeQuantity) {
          nativeQuantity.value = String(next);
          nativeQuantity.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (stickyQuantityValue) stickyQuantityValue.textContent = String(next);
        return;
      }
      const control = event.target.closest('[data-product-step]');
      if (!control || !productPage.contains(control)) return;
      changeQuantity(control.dataset.productStep);
    });

    productPage.addEventListener('change', (event) => {
      if (event.target.matches('[data-sticky-size]')) {
        const selectedChoice = sizeChoices.find((choice) => choice.value === event.target.value);
        selectedChoice?.click();
        setStatus('');
        refreshControls();
        return;
      }
      if (event.target.matches('[data-sticky-option]')) {
        syncStickyOption(event.target.dataset.stickyOption, event.target.value);
        return;
      }
      if (event.target.matches('[data-product-size-choice]')) {
        setStatus('');
        syncStickyOptionControls();
        refreshControls();
        return;
      }
      if (event.target.closest('variant-selects')) window.setTimeout(() => {
        syncStickyOptionControls();
        refreshControls();
      }, 350);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source === 'product-form' || event.source === 'cart-items') refreshControls();
      });
      subscribe(PUB_SUB_EVENTS.variantChange, () => window.setTimeout(refreshControls, 0));
    }

    desktopQuery.addEventListener('change', refreshControls);
    syncStickyOptionControls();
    refreshControls();
  });
})();
